import * as constants from './constants';

export default function getBreakPoints(serverWidth, serverHeight) {
    let width = serverWidth;
    let height = serverHeight;

    if (typeof (window) !== 'undefined') {
        // on the client use the clients window width and height
        width = window.innerWidth;

        height = window.innerHeight;
    }

    let isExtraSmall = false;
    let isSmall = false;
    let isMedium = false;
    let isLarge = false;
    let isExtraLarge = false;

    if (width < constants.XS_UPPER) {
        isExtraSmall = true;
    } else if (width < constants.SM_UPPER) {
        isSmall = true;
    } else if (width < constants.MD_UPPER) {
        isMedium = true;
    } else if (width < constants.LG_UPPER) {
        isLarge = true;
    } else { isExtraLarge = true; }

    return {
        height,
        width,
        isExtraSmall,
        isSmall,
        isMedium,
        isLarge,
        isExtraLarge,
    };
}
